import { StateCreator } from "zustand";
import type { AuthorizedUser } from "@/core/auth/action.auth";

import { GlobalState } from "../globalStore";

export interface AuthSlice {
  // State
  user: AuthorizedUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  meiliUserToken: string | null; // Optional Meilisearch user token
  meiliUserTokenExpiresAt: string | null;
  isInitialized: boolean; // tack if state is initialized ()
  isUserAdmin: boolean; // Track if user has admin role

  // Actions
  setUser: (user: AuthorizedUser | null) => void;
  setTokens: (
    accessToken: string | null,
    refreshToken: string | null,
    meiliUserToken: string | null,
    meiliUserTokenExpiresAt?: string | null,
  ) => void;
  logout: () => void;
}

export const createAuthSlice: StateCreator<GlobalState, [], [], AuthSlice> = (
  set,
  get,
) => ({
  user: null,
  accessToken: null,
  refreshToken: null,
  meiliUserToken: null,
  meiliUserTokenExpiresAt: null,
  isInitialized: false,
  isUserAdmin: false,

  setUser: (user) => {
    const isUserAdmin = user?.roles.includes("admin") ?? false; // Determine admin status
    set({ user, isUserAdmin });
  },
  setTokens: (
    //
    accessToken,
    refreshToken,
    meiliUserToken,
    meiliUserTokenExpiresAt = null,
  ) => {
    //! Without Meili
    // set({ accessToken, refreshToken });
    // // Get current user from state to check if it exists
    // const state = get();
    // // Only mark as initialized if all required auth data is present
    // if (accessToken && refreshToken && state.user) {
    //   set({ isInitialized: true });
    // }
    //! With Meili
    set({
      accessToken,
      refreshToken,
      meiliUserToken,
      meiliUserTokenExpiresAt,
    });
    // Get current user from state to check if it exists
    const state = get();
    // Only mark as initialized if all required auth data is present
    if (accessToken && refreshToken && meiliUserToken && state.user) {
      set({ isInitialized: true });
    }
  },
  logout: () => {
    //! Without Meili
    // set({ user: null, accessToken: null, refreshToken: null });
    // // Reset isInitialized to false on logout
    // set({ isInitialized: false });
    //! With Meili
    set({
      user: null,
      accessToken: null,
      refreshToken: null,
      meiliUserToken: null,
      meiliUserTokenExpiresAt: null,
      isUserAdmin: false,
    });
    // Reset isInitialized to false on logout
    set({ isInitialized: false });
  },
});
